import './ParameterVideos.scss';
import { ParameterModel, VideoUrlModel } from 'types/trackmanParameters';

import Paragraph from 'components/TextComps/Paragraph';
import VideoThumbnail from 'components/VideoThumbnail/VideoThumbnail';
import YouTubeVideoPlayer from 'components/YouTubeVideoPlayer/YouTubeVideoPlayer';
import { useTranslation } from 'react-i18next';

type Props = {
  visibleParameter: ParameterModel;
  visibleVideo: VideoUrlModel;
  setVisibleVideo: (video: VideoUrlModel) => void;
};

export const ParameterVideos = ({ visibleParameter, visibleVideo, setVisibleVideo }: Props) => {
  const { t } = useTranslation();

  return (
    <div className='videos-info'>
      <YouTubeVideoPlayer title={visibleVideo.label} youTubeId={visibleVideo.videoUrl} />
      <h3>{t('Videos', { ns: 'trackmanParameters' })}</h3>
      <Paragraph>
        <strong>{t('WhatIsThisParameter', { ns: 'trackmanParameters', parameterTitle: visibleParameter.title })}</strong>
      </Paragraph>
      {visibleParameter.videoUrls.length > 1 ? (
        <div className='videos-list'>
          {visibleParameter.videoUrls.map((video: VideoUrlModel) => (
            <VideoThumbnail key={video.videoUrl} video={video} setVisibleVideo={setVisibleVideo} />
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ParameterVideos;
